<template>

  <b-card :title="title">

    <b-alert variant="success" v-model="uploadSuccess"> Udało się</b-alert>
    <b-alert variant="danger" v-model="uploadError"> Coś poszło nie tak</b-alert>


    <b-form-group>
      <b-form-file
          v-model="file"
          placeholder="Wybierz plik"
          drop-placeholder="Upuść tutaj"
          :disabled="!enabled"
      ></b-form-file>
    </b-form-group>


    <b-alert variant="info" show>
      {{ info }}
    </b-alert>

    <div class="vdist">
      <b-progress max="100" :value="uploadPercentage"></b-progress>
    </div>

    <b-button v-on:click="submitFile()" :disabled="enabled===false || file===null || uploadPercentage!==null">Submit</b-button>


  </b-card>


</template>

<script>

import {api} from '@/utils'

export default {
  name: 'Etl',
  props: ["axios", "endpoint", "info", "enabled", "title"],
  data: function () {
    return {
      file: null,
      uploadPercentage: null,
      uploadSuccess :null,
      uploadError:null
    }
  },
  methods: {
    submitFile() {
      let formData = new FormData();
      formData.append('file', this.file);
      this.uploadPercentage=0;
      this.axios.post(api(this.endpoint),
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: function (progressEvent) {
              this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
            }.bind(this)
          }
      ).then(() =>{
        this.uploadSuccess=5;
        this.file = null;
        this.uploadPercentage=null;
      }).catch(() =>{
        this.uploadError=5;
        this.file = null;
        this.uploadPercentage=null;
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
